import { z } from "zod";

export const createServiceSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().max(500).optional(),
  durationMinutes: z.number().int().min(5).max(480),
  priceInCents: z.number().int().min(0),
  sortOrder: z.number().int().min(0).optional(),
});

export const updateServiceSchema = createServiceSchema.partial();

export const reorderServicesSchema = z.object({
  serviceIds: z.array(z.string().min(1)),
});

export const createBookingSchema = z.object({
  businessId: z.string().min(1),
  serviceId: z.string().min(1),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  startTime: z.string().regex(/^\d{2}:\d{2}$/),
  guestName: z.string().min(1).max(100).optional(),
  guestEmail: z.email().optional(),
  guestPhone: z.string().min(1).max(20).optional(),
  notes: z.string().max(500).optional(),
});

export const cancelBookingSchema = z.object({
  reason: z.string().max(500).optional(),
});

export const guestLookupSchema = z.object({
  email: z.email(),
  code: z.string().min(1),
});

export const slotsQuerySchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  serviceId: z.string().min(1),
});

export type CreateServiceInput = z.infer<typeof createServiceSchema>;
export type UpdateServiceInput = z.infer<typeof updateServiceSchema>;
export type ReorderServicesInput = z.infer<typeof reorderServicesSchema>;
export type CreateBookingInput = z.infer<typeof createBookingSchema>;
export type CancelBookingInput = z.infer<typeof cancelBookingSchema>;
export type GuestLookupInput = z.infer<typeof guestLookupSchema>;
export type SlotsQueryInput = z.infer<typeof slotsQuerySchema>;
